<template>
  <v-flex
    xs12
    sm4
    offset-sm1
  >
    <MagentoDetail
      v-on:mageModalclose="magentoDialog = false"
      :assetList='[assetDetail]'
      v-if="magentoDialog && !annoy"
    />
    <EditDetailsMonitor
      v-on:computerDetailModalClose="computerDetailDialog = false"
      v-if='computerDetailDialog && !annoy'
      :assetDetail='assetDetail'
    />

    <v-card class='mt-5'>
      <v-toolbar
        color="secondary"
        dark
      >
        <v-toolbar-title>{{assetDetail.Discovery.AssetTag}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-avatar
          v-if='!annoy'
          @click='magentoDialog = true'
          :tile="true"
          :size="25"
        >
          <img
            style='cursor : pointer ; width : 100% ;margin-right : 50%'
            title='push item to magento'
            src="https://firebasestorage.googleapis.com/v0/b/tech-reuse.appspot.com/o/112651_development_435x512.png?alt=media&token=842aeaf9-f41d-4b86-a0d3-471952d2d437"
          >
        </v-avatar>

        <v-btn
          v-if='!annoy'
          icon
          @click="computerDetailDialog = true"
        >
          <v-icon>edit</v-icon>
        </v-btn>

      </v-toolbar>

      <v-list two-line>
        <v-list-tile>
          <v-list-tile-action>
            <v-avatar
              :tile="true"
              :size="30"
            >
              <img src="https://img.icons8.com/ios/50/000000/organization-filled.png">
            </v-avatar>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{assetDetail.Discovery.Brand}}</v-list-tile-title>
            <v-list-tile-sub-title>Brand</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider inset></v-divider>
        <v-list-tile>
          <v-list-tile-action>
            <v-avatar
              :tile="true"
              :size="30"
            >
              <img src="https://img.icons8.com/material/48/000000/laptop.png">
            </v-avatar>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{assetDetail.Discovery.Model}}</v-list-tile-title>
            <v-list-tile-sub-title>Model</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider inset></v-divider>
        <v-list-tile>
          <v-list-tile-action>
            <v-avatar
              :tile="true"
              :size="30"
            >
              <img src="https://img.icons8.com/ios/50/000000/bag-brand.png">
            </v-avatar>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{assetDetail.Discovery.Serial}}</v-list-tile-title>
            <v-list-tile-sub-title>Serial</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider inset></v-divider>
        <v-list-tile>
          <v-list-tile-action>
            <v-avatar
              :tile="true"
              :size="30"
            >
              <img src="https://img.icons8.com/ios/50/000000/aspect-ratio.png">
            </v-avatar>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>{{assetDetail.Discovery.Imei}}</v-list-tile-title>
            <v-list-tile-sub-title>IMEI</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider inset></v-divider>
        <v-list-tile>
          <v-list-tile-action>
            <v-avatar
              :tile="true"
              :size="30"
            >
              <img src="https://img.icons8.com/metro/52/000000/pallet.png">
            </v-avatar>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title
              v-if='assetDetail.Discovery.location'
              style='cursor : pointer;color:blue'
              @click='goTo'
            >{{assetDetail.Discovery.location}}</v-list-tile-title>
            <v-list-tile-sub-title>Location</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-card>
  </v-flex>
</template>


<script>
import MagentoDetail from '../components/MagentoDialog.vue'
import EditDetailsMonitor from '../components/EditDetailsMonitor'

export default {
  components: {
    MagentoDetail,
    EditDetailsMonitor
  },
  props: {
    assetDetail: Object,
    annoy: Boolean
  },
  data () {
    return {
      Printdialog: false,
      magentoDialog: false,
      computerDetailDialog: false
    }
  },
  methods: {

  }
}
</script>
